import { render, staticRenderFns } from "./PanelContentItemShowContentModal.vue?vue&type=template&id=56650bb4&scoped=true&"
import script from "./PanelContentItemShowContentModal.vue?vue&type=script&lang=ts&"
export * from "./PanelContentItemShowContentModal.vue?vue&type=script&lang=ts&"
import style0 from "./PanelContentItemShowContentModal.vue?vue&type=style&index=0&id=56650bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56650bb4",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection});
